import * as React from "react";
import * as ReactDOM from "react-dom";
import { UserContextContants } from "../context/UserContext";
import { sessionListener, emitSessionChange } from "./SessionListener";
interface State {
  signedIn: boolean;
}

class MenuExtension extends React.Component<{}, State> {
  state = {
    signedIn: false,
  };

  componentDidMount() {
    this.updateSignedIn(
      !!sessionStorage.getItem(UserContextContants.tokenStorage)
    );
    sessionListener((signedIn: boolean) => this.updateSignedIn(signedIn));
  }

  updateSignedIn(signedIn: boolean) {
    this.setState({
      signedIn,
    });
  }

  signOut = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    sessionStorage.removeItem(UserContextContants.tokenStorage);
    this.setState({
      signedIn: false,
    });

    emitSessionChange(false);
    event.preventDefault();
    $(".navbar-collapse").collapse("hide");
  };

  render() {
    return this.state.signedIn ? (
      <li className="nav-item">
        <a className="nav-link text-uppercase" onClick={this.signOut} href="#">
          Logga ut
        </a>
      </li>
    ) : null;
  }
}

ReactDOM.render(<MenuExtension />, document.getElementById("menu-extension"));
